import React, { useEffect } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { DataGridButton, UserDeleteOptionsGreen, UserDeleteOptionsRed } from "../styles";

interface Props {
  id: string;
  type: string;
  version: string;
  code: string;
}

const UsedByList: React.FC<Props> = (props) => {
  const [ID, setID] = React.useState("");
  const [usedBy, setUsedBy] = React.useState<any[]>([]);

  const columns: any[] = [
    {
      field: 'user', headerName: 'User', width: 240,
    },
    {
      field: "action",
      headerName: "Action",
      width: 240,
      renderCell: (params: any) => (
        <span style={{}}>
          {ID === params.row.id ? (
            <>
              Revoke?{" "}
              <UserDeleteOptionsRed
                onClick={() => {
                  onDelete({ code: props.code, username: params.row.user });
                  setID("");
                }}
              >
                Yes
              </UserDeleteOptionsRed>{" "}
              <UserDeleteOptionsGreen
                onClick={() => {
                  setID("");
                }}
              >
                No
              </UserDeleteOptionsGreen>
            </>
          ) : (
            <DataGridButton
              style={{ color: "#DB3A34", border: "2px solid #DB3A34" }}
              onClick={() => {
                setID(params.row.id);
              }}
            >
              Revoke
            </DataGridButton>
          )}
        </span>
      ),
    },
  ];

  const getUsedByList = (params: {
    code: string;
  }) => {
    fetch("/api/v1/software/type/version/activationCode/listAllowedUsers", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        software: props.id,
        type: props.type,
        version: props.version,
        code: params.code,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === true) {
          setUsedBy(data.users.map((item: any, index: number) => ({
            id: index,
            user: item.user,
          })));
        }
      }).catch((err) => console.log("Error while fetching used by list:", err));
  }

  const onDelete = (params: {
    code: string;
    username: string;
  }) => {
    fetch("/api/v1/software/type/version/activationCode/revoke", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        software: props.id,
        type: props.type,
        version: props.version,
        code: params.code,
        username: params.username,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === true) {
          console.log("User deleted successfully");
          getUsedByList({ code: props.code });
        }
      }).catch((err) => console.log("Error while deleting user:", err));
  }

  useEffect(() => {
    getUsedByList({ code: props.code });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ height: 500, width: '100%', paddingTop: "2rem" }}>
      <DataGrid
        style={{ fontWeight: 900, color: "rgba(55, 73, 87, 0.7)" }}
        rows={usedBy}
        columns={columns}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        components={{ Toolbar: GridToolbar }}
        componentsProps={{
          toolbar: {
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500 },
          },
        }}
      />
    </div>
  );
}

export default UsedByList;
